import React, { Component } from 'react';
import Tabbar from '../../../Components/Tabbar/Tabbar';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ResourcesEditAddComponent from '../../../Components/Pages/ResourcesEditAddComponent';
import { getAll, del, getRooms, clearErrs, getOne, edit } from '../../../Store/Actions/RestActions';
import ErrorModal from '../../../Components/errorModal';
import './ResourcesEdit.css';
class ResourcesEditPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			assetDetails: [],
			assetTypeId: '',
			buildingId: '',
			description: '',
			floorId: '',
			isFixed: false,
			name: '',
			roomId: ''
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleCheckboxAndInputChange = this.handleCheckboxAndInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

	}
	componentDidMount() {
		const locationSteal = window.location.pathname.match(/\/resources\/(.*)/);
		if (locationSteal.length > 1) {
			this.setState({ id: locationSteal[1] });
			this.props.resourceFetch(locationSteal[1]);
			this.props.buildingsFetch();
			this.props.floorsFetch();
			this.props.roomFetch();
			this.props.assetTypesFetch();
			this.props.assetDetailTypeFetch();
			this.props.roomDetailTypesFetch();
		}
	}
	componentWillReceiveProps(newProps) {
		if (newProps.assets.id) {
			let temp = Object.assign({}, newProps.assets);

			if (newProps.assets.assetType) {
				temp = Object.assign(temp, { assetTypeId: newProps.assets.assetType.id });
			}

			//fix for assetDetails
			if (newProps.assets.assetDetails) {
				if (newProps.assets.assetDetails.length > 0) {
					let tempArr = [];
					newProps.assets.assetDetails.forEach((e) => {
						if (e.assetDetailType) {
							let tempObj = {};
							tempObj.AssetDetailTypeId = e.assetDetailType.id;
							tempObj.Id = e.id;
							tempObj.Value = e.value;
							tempObj.AccountId = this.props.accountId;
							tempArr.push(tempObj);

						}
					});
					temp.assetDetails = tempArr;
				}
			}

			this.setState(temp);
		}
	}
	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		if (name === "buildingId" || name === "floorId") {
			this.setState({
				roomId: ''
			});
		}
		this.setState({
			[name]: value
		});
	}

	handleCheckboxChange(assetType) {
		this.setState({ assetTypeId: assetType[0] });
	}

	handleCheckboxAndInputChange(assetDetails) {
		this.setState({ assetDetails });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.editResource(this.state, this.state.id);
	}
	render() {
		if (this.props.fireRedirect) {
			return (
				<Redirect to="/resources" />
			);
		}
		return (
			<div className="container">
				<Tabbar setActiveTab="resources" />
				<div className="contentBox tabbed-content-box addResource">
					<h3>Edit Resource</h3>
					<ResourcesEditAddComponent state={this.state} editValue={true} {...this.props} handleInputChange={this.handleInputChange} handleSubmit={this.handleSubmit} handleCheckboxAndInputChange={this.handleCheckboxAndInputChange} />
				</div>
				<ErrorModal error={this.props.error} errMsg={this.props.errMsg} formError={this.props.formError} onClose={this.props.clearError}></ErrorModal>
			</div>
		);
	}

}
const mapStateToProps = (state) => {
	return {
		assets: state.assets.data,
		assetTypes: state.assetTypes.data,
		assetDetailTypes: state.assetDetailTypes.data,
		buildings: state.buildings.data,
		floors: state.floors.data,
		rooms: state.rooms.data,
		error: state.assets.hasError,
		errMsg: state.assets.errMsg,
		fireRedirect: state.assets.redirect,
		accountId: state.auth.accountId
	};
};

const mapDispatchtoProps = (dispatch) => {
	return {
		editResource: (data, id) => dispatch(edit('assets', data, id)),
		roomFetch: () => dispatch(getRooms()),
		// roomTypeFetch: () => dispatch(getAll('roomtypes', {})),
		roomDetailTypesFetch: () => dispatch(getAll('roomdetailtypes', {})),
		assetTypesFetch: () => dispatch(getAll('assettypes', {})),
		assetDetailTypeFetch: () => dispatch(getAll('assetdetailtypes', {})),
		assetsFetch: () => dispatch(getAll('assets', {})),
		buildingsFetch: () => dispatch(getAll('buildings', {})),
		floorsFetch: () => dispatch(getAll('floors', {})),
		clearError: () => dispatch(clearErrs('assets')),
		resourceFetch: id => dispatch(getOne('assets', {}, id)),
		deleteClick: (id) => dispatch(del('resources', {}, id)),
	};
};
export default connect(mapStateToProps, mapDispatchtoProps)(ResourcesEditPage);



// WEBPACK FOOTER //
// ./src/Pages/Resources/ResourcesEdit/ResourcesEdit.js